<template>
  <div class="about_box">
    <!-- pc -->
    <div class="pc_box">
      <div class="bg_header">
        <center class="header_center_box">
          <img src="../../../assets/newWebSiteImg/pc/home/bg1.jpg" alt="">
        </center>
      </div>

      <div class="content_box">
        <div></div>
        <div class="info_box">
          <div class="desc_box">
            <p class="title">智慧链接酒店资源，赋能商旅价值跃升</p>
            <p class="desc">
              <span style="display: block;">依托数字化技术整合全球酒店资源，为商旅企业客户提供实时标准化库存、在线预订、协议酒店托管及统一结算的一站式供应链解决方案。</span>
            </p>
            <b2b-button
              style="width: 100px;height: 40px;line-height: 40px;background-color:#fe8f1d;margin-top: 40px;box-shadow: 0 0 4px rgba(0, 0, 0, .4);"
              @click="$router.push('solution')">了解更多</b2b-button>
          </div>
          <div class="service_box">
            <div class="service_item">
              <div class="service_desc">
                <p>100w+全球酒店资源</p>
                <p>分布在全球7500多个主流城市</p>
              </div>
            </div>
            <div class="service_item">
              <div class="service_desc">
                <p>15年+API对接经验</p>
                <p>接口安全可靠，响应速度快</p>
              </div>
            </div>
            <div class="service_item">
              <div class="service_desc">
                <p>7*24小时专属客服团队</p>
                <p>专业高效，值得信赖</p>
              </div>
            </div>
          </div>
          <div class="company_box">
            <div style="margin: 100px 0;">
              <Title>公司介绍</Title>
            </div>
            <div class="desc">
              深圳市科坦科技有限公司（简称“科坦科技”）成立于2019年，是一家专注于商旅酒店供应链管理和解决方案服务商。公司秉承“信息化、数字化、智能化”的经营理念，致力于为TMC（商旅管理公司）、大型企业集团、旅行社等提供全方位、一站式的供应链管理解决方案。凭借其强大的技术实力和专业的运营团队，科坦科技已迅速发展成为行业初具影响力的企业。
              科坦科技的核心团队成员来自Expedia、携程、华为等知名企业，拥有超过15年+的技术研发和运营管理经验，能够精准把握行业发展趋势和客户需求，为公司的发展提供了坚实的技术和管理保障。
              科坦科技凭借其卓越的技术实力和专业的服务团队，为客户提供高效、便捷、可靠的商旅酒店供应链管理服务。未来，科坦科技将继续秉承“信息化、数字化、智能化”的理念，不断创新和发展，为行业和社会创造更大的价值。
            </div>
            <div class="idea">
              <div class="idea_item">
                <div style="overflow: hidden;">
                  <img src="@/assets/newWebSiteImg/pc/home/idea_left.png" alt="" />
                </div>
                <p class="idea_title">使命</p>
                <p class="idea_desc">智慧链接酒店资源，赋能商旅价值跃升</p>
              </div>
              <div class="idea_item">
                <div style="overflow: hidden;">
                  <img src="@/assets/newWebSiteImg/pc/home/idea_mid.png" alt="" />
                </div>
                <p class="idea_title">愿景</p>
                <p class="idea_desc">做全球商旅供应链服务标杆</p>
              </div>
              <div class="idea_item">
                <div style="overflow: hidden;">
                  <img src="@/assets/newWebSiteImg/pc/home/idea_right.png" alt="" />
                </div>
                <p class="idea_title">价值观</p>
                <p class="idea_desc">诚信务实、合作共赢、创新求变、追求卓越</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="development_box">
        <div></div>
        <div class="development_content">
          <Title style="color:#fff;">发展历程</Title>
          <div class="development_info">
            <div class="detail">
              <div class="detail_item">
                <p class="year">2019</p>
                <p class="event">在中国深圳注册成立</p>
              </div>
            </div>
            <div class="detail">
              <div class="detail_item">
                <p class="year">2020</p>
                <p class="event">科坦酒店智能交易管理平台 上线投入使用，大规模接入 供应商及客户资源。</p>
              </div>
            </div>
            <div class="detail">
              <div class="detail_item">
                <p class="year">2021</p>
                <p class="event">交易额突破3000万</p>
              </div>
            </div>
            <div class="detail">
              <div class="detail_item">
                <p class="year">2022</p>
                <p class="event">交易额突破1亿</p>
              </div>
            </div>
            <div class="detail">
              <div class="detail_item">
                <p class="year">2023</p>
                <p class="event">深入行业，提升品牌影响力。</p>
              </div>
            </div>
            <div class="detail">
              <div class="detail_item">
                <p class="year">2024</p>
                <p class="event">深耕国内，拓展海外市场，与更多合作伙伴共同成长。</p>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      <div class="partner_box">
        <div></div>
        <div style="padding: 0 80px;">
          <Title style="margin-bottom: 50px;">部分合作伙伴</Title>
          <div class="partners_content" v-for="(item, index) in partnerList" :key="index">
            <div class="partner_type"></div>
            <div class="partner_item" v-for="(i, ind) in item.imgList" :key="ind">
              <img :src="i.src" :style="{width: i.width ? i.width : '140px', height: i.height ? i.height : '100%'}"/>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      <div class="main_body_register">
        <div class="to_register">
          <div style="margin-bottom: 30px;">
            <span style="font-size: 30px;font-weight: bold;">{{ $t('login.get_hotels') }}</span>
          </div>
          <div>
            <span
              style="font-size: 15px;border: 1px solid #fff;padding: 6px 22px;font-family: '苹方';border-radius: 5px;cursor: pointer;"
              @click="toRegister">
              {{ $t('login.register_now').replace(',', '') }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动 -->
    <div class="app_box">

    </div>
  </div>
</template>

<script>
// E:\newWorks\B2BWebsite\src\assets\newWebSiteImg\pc\home\partners
import Title from '../components/Title.vue';
export default {
  data () {
    return {
      partnerList: [{
        partnerType: '酒店伙伴',
        imgList: [{
          src: require('@/assets/newWebSiteImg/pc/home/partners/jinjiang.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/rujia.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/atour.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/qz.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/yst.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/qiuguo.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/kaiyuan.png'),
          width: '100%',
          height: '100%'
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/dossen.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/rezengroup.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/elong (2).png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/kl.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/ctriptavel.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/figbig.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/mfmeituan.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/qurae.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/tuniu.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/hrs.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/elong.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/alibt.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/ztbt.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/cyts.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/TBO.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/rate hawk.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/miki.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/booking.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/expedia.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/hotelbeds.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/webbeds.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/didatravel.png')
        }, {
          src: require('@/assets/newWebSiteImg/pc/home/partners/rakuten.png')
        }]
      }]
    }
  },
  components: {
    Title
  },
  methods: {
    toRegister () {
      window.open('/Register', '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.about_box {

  @media screen and (min-width: 992px) {
    .pc_box {
      display: block;
      min-height: 100vh;

      .bg_header {
        height: 720px;
        background-color: #f3f8fe;

        img {
          width: 1401px;
        }
      }

      .content_box {
        display: grid;
        grid-template-columns: auto 1401px auto;
        position: relative;
        top: -600px;

        .info_box {
          .desc_box {
            width: 62%;
            margin: auto;
            text-align: center;
            color: #565555;
            margin-top: 25px;

            .title {
              font-size: 42px;
              font-weight: bold;
              color: #565555;
              letter-spacing: 2px;
            }

            .desc {
              font-size: 14px;
              margin-top: 20px;
              line-height: 25px;
            }
          }

          .service_box {
            margin-top: 250px;
            display: grid;
            grid-template-columns: repeat(3, 420px);
            grid-column-gap: 70px;

            .service_item {
              min-height: 200px;
              background-color: #fff;
              border-radius: 4px;
              box-shadow: 5px 5px 20px #1312121c;
              position: relative;
              text-align: center;

              .service_desc {
                width: 80%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-family: '苹方';
                color: #565555;

                p:first-child {
                  font-size: 30px;
                  margin-bottom: 20px;
                }

                p:last-child {
                  font-size: 14px;
                }
              }

              &:first-child {
                border-bottom: 5px solid #87c916;
              }

              &:nth-child(2) {
                border-bottom: 5px solid #307fe2;
              }

              &:nth-child(3) {
                border-bottom: 5px solid #fe8f1d;
              }
            }
          }

          .company_box {
            width: 85%;
            margin: auto;

            .desc {
              font-size: 14px;
              font-family: '苹方';
              line-height: 28px;
              color: #8c8b8b;
              margin-bottom: 70px;
            }


            .idea {
              display: grid;
              grid-template-columns: repeat(3, auto);
              grid-column-gap: 15px;

              .idea_item {
                min-height: 250px;
                text-align: center;
                box-shadow: 2px 2px 10px #1312121c;
                color: #565555;

                &:hover {
                  img {
                    transform: scale(1.1);
                  }
                }

                img {
                  width: 100%;
                  height: 130px;
                  object-fit: cover;
                  transition: all .8s;
                }

                .idea_title {
                  font-family: '苹方';
                  margin-top: 30px;
                  font-size: 24px;
                  font-weight: 600;
                }

                .idea_desc {
                  font-size: 14px;
                  margin-top: 20px;
                }
              }
            }
          }

          /deep/.b2b_button:hover {
            background-color: #ff9b34 !important;
          }
        }
      }

      .development_box {
        margin-top: -500px;
        background-image: url('../../../assets/newWebSiteImg/pc/home/bg2.png');
        height: 700px;
        background-size: 100% 700px;

        display: grid;
        grid-template-columns: auto 1401px auto;

        .development_content {
          padding: 8% 163px 2% 163px;

          .development_info {
            margin-top: 20px;
            display: grid;
            grid-template-columns: repeat(6, auto);
            grid-column-gap: 15px;
            height: 90%;

            .year {
              font-size: 24px;
              color: #df8736;
              font-weight: 600;
              margin-bottom: 10px;
            }

            .event {
              color: #fff;
              font-size: 14px;
              line-height: 25px;
            }

            .detail:first-child {
              position: relative;

              .detail_item {
                position: absolute;
                bottom: 0;
                padding-left: 20px;
                height: 150px;
                border-left: 1px solid #969696;
              }
            }

            .detail:nth-child(2) {
              position: relative;

              .detail_item {
                position: absolute;
                bottom: 4%;
              }
            }

            .detail:nth-child(3) {
              position: relative;

              .detail_item {
                position: absolute;
                bottom: 15%;
              }
            }

            .detail:nth-child(4) {
              position: relative;

              .detail_item {
                position: absolute;
                bottom: 25%;
              }
            }

            .detail:nth-child(5) {
              position: relative;

              .detail_item {
                position: absolute;
                bottom: 35%;
              }
            }

            .detail:nth-child(6) {
              position: relative;

              .detail_item {
                position: absolute;
                bottom: 45%;
              }
            }

            .detail:not(:first-child) {

              .detail_item {
                padding-left: 20px;
                height: 230px;
                border-left: 1px solid #969696;
              }
            }
          }
        }
      }

      .partner_box {
        margin-top: 80px;
        display: grid;
        grid-template-columns: auto 1401px auto;

        .partners_content {
          margin-top: 20px;

          display: grid;
          grid-template-columns: repeat(5, 197px);
          grid-gap: 10px;
          margin-left: 110px;

          .partner_type {
            grid-column-start: 1;
            grid-column-end: 6;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 13px;
            color: #565555;
            font-size: '苹方';
            letter-spacing: 1px;
          }

          .partner_item {
            width: 197px;
            height: 80px;
            line-height: 60px;
            text-align: center;
            border: 1px solid #e9e9e9;
            padding: 8px;

            img {
              width: 140px;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }

      .main_body_register {
        background-image: url('../../../assets/newImage/bg_1.jpg');
        width: 100%;
        height: 150px;
        background-size: cover;
        text-align: center;
        color: #fff;
        position: relative;
        margin-top: 100px;

        .to_register {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .app_box {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    .pc_box {
      display: none;
    }

    .app_box {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newWebsite/main/aboutUs.vue